/* lua.js generated code 0.3.0 */

var GameGuideData = require("clover/gameGuide/GameGuideData")
var GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
var GameGuideFunc = require("clover/gameGuide/GameGuideFunc")
var GameGuideMask = require("clover/gameGuide/GameGuideMask")
var GameGuidePosition = require("clover/gameGuide/GameGuidePosition")
var GameGuideRunner = {}
GameGuideRunner.runGuide = function (paras) {
    var self = this
    var action = GameGuideData.getInstance().getRunningAction()
    self.setGuideLayer(action, paras)
    for (var i = 1, v = action[1]; v; i++, v = action[i]) {
    // GameSpeedUp.getInstance().speedNormal()
    // GameSpeedUp.getInstance().lockSpeed()
        var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
        if (type(self["run" + funcName]) === "function") {
            self["run" + funcName](i, v, paras)
        } else if (__WIN32) {
            assert(false, "Invalid game guide action type (run): " + tostring(v.type))
        }
    }
    GameGuideData.getInstance().setActionReleased(false)
}
GameGuideRunner.removeGuide = function (paras) {
    var self = this
    // GameSpeedUp.getInstance().unlockSpeed()
    // GameSpeedUp.getInstance().speedUp()
    if (GameGuideData.getInstance().getActionReleased()) {
        return 
    }
    GameGuideData.getInstance().setActionReleased(true)
    var action = GameGuideData.getInstance().getRunningAction()
    self.setGuideLayer(action, paras)
    var [success, rec] = [false, false]
    for (var i = 1, v = action[1]; v; i++, v = action[i]) {
        var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
        if (type(self["remove" + funcName]) === "function") {
            var [suc, r] = self["remove" + funcName](i, v, paras) || []
            ;[success, rec] = [success && suc, rec && r]
        } else {
            ;[success, rec] = [true, true]
        }
    }
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.removeAllChildren()
    }
    GameGuideData.getInstance().resetGuideLayer()
    // FIXME: multi result
    return [success, rec]
}
GameGuideRunner.setGuideLayer = function (action, paras) {
    var self = this
    // if (type(action.guideLayer) === "string") {
    //     if (action.guideLayer === "levelNode") {
    //         var scene = cc.Director.getInstance().getRunningScene()
    //         var sceneName = tostring(((scene || table()).class || table()).__cname)
    //         if (sceneName === "HomeScene" && scene.homeSceneMap.guideLayer) {
    //             GameGuideData.getInstance().setGuideLayer(scene.homeSceneMap.guideLayer)
    //             return 
    //         }
    //     }
    // }
    var guideLayer = (cc.Director.getInstance().getRunningScene() || table()).guideLayer
    GameGuideData.getInstance().setGuideLayer(guideLayer)
}
GameGuideRunner.runAutoFinish = function (index, action, paras) {
    var self = this
    var node = GameGuideAnims.autoFinishNode(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(node)
    }
}
GameGuideRunner.runClickHand = function (index, action, paras) {
    var self = this
    var hand = GameGuideAnims.handClick(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(hand)
    }
}
GameGuideRunner.runLockPropBarSlide = function (index, action, paras) {
    var self = this
    var node = GameGuideAnims.lockGamePropBarSlide(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(node)
    }
}
GameGuideRunner.runMask = function (index, action, paras) {
    var self = this
    var mask = GameGuideMask.create(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(mask)
    }
}
        // GameSpeedUp.getInstance().unlockSpeed()
        // GameSpeedUp.getInstance().speedUp()
GameGuideRunner.runSkipButton = function (index, action, paras) {
    var self = this
    var button = GameGuideAnims.skipButton(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(button)
    }
}
GameGuideRunner.runSwapHand = function (index, action, paras) {
    var self = this
    var hand = GameGuideAnims.handSwap(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(hand)
    }
}
GameGuideRunner.runAnimalBubbleUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalJumpUpWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalBubbleDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalJumpDownWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalFadeUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalFadeUpWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalFadeDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalFadeDownWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalSlideUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalSlideUpWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalSlideDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalSlideDownWithBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalBubbleUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalJumpUp(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalBubbleDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalJumpDown(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalFadeUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalFadeUp(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalFadeDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalFadeDown(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalSlideUp = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalSlideUp(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runSingleAnimalSlideDown = function (index, action, paras) {
    var self = this
    var panel = GameGuideAnims.animalSlideDown(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runGameEliminateAdvice = function (index, action, paras) {
    var self = this
    GameGuideFunc.gameEliminateAdvise(action, paras)
}
GameGuideRunner.runEnableProp = function(index, action, paras) {
    let self = this;
    let scene = cc.Director.getInstance().getRunningScene();
    if (!scene || scene.name != "GameScene") {
        return;
    }
    scene.ui.gamePropBar.bubbleLayer.setBubbleEnabledGuide(action.propId)
}
GameGuideRunner.runGuideProp = function (index, action, paras) {
    let self = this
    if ((action.runTime || "start") === "start") {
        if (action.delay) {
            let node = GameGuideAnims.guideProp(action, paras)
            let layer = GameGuideData.getInstance().getGuideLayer()
            if (layer) {
                layer.addChild(node)
            }
        } else {
            GameGuideFunc.guideProp(action, paras)
        }
    }
}
GameGuideRunner.removeGuideProp = function (index, action, paras) {
    let self = this
    if ((action.runTime || "start") === "end") {
        if (action.delay) {
            let layer = GameGuideData.getInstance().getGuideLayer()
            if (layer) {
                layer.runAction(cc.CallFunc.create(function () {
                    let node = GameGuideAnims.guideProp(action, paras)
                    layer.addChild(node)
                }))
            }
        } else {
            GameGuideFunc.guideProp(action, paras)
        }
    }
}
GameGuideRunner.runAnimation = function (index, action, paras) {
    var self = this
    var anim = GameGuideAnims.singleAnimation(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(anim)
    }
}
GameGuideRunner.runText = function (index, action, paras) {
    var self = this
    var text = GameGuideAnims.singleText(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(text)
    }
}
GameGuideRunner.runBubble = function (index, action, paras) {
    var self = this
    var text = GameGuideAnims.singleBubble(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(text)
    }
}
GameGuideRunner.runButton = function (index, action, paras) {
    var self = this
    var button = GameGuideAnims.singleButton(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(button)
    }
}
GameGuideRunner.runBoard = function (index, action, paras) {
    var self = this
    var board = GameGuideAnims.singleBoard(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(board)
    }
}
GameGuideRunner.runSelectProp = function (index, action, paras) {
    var self = this
    GameGuideFunc.selectPropBarProp(action, paras)
}
GameGuideRunner.runImageMove = function (index, action, paras) {
    var self = this
    if ((action.runTime || "start") === "start") {
        var layer = GameGuideData.getInstance().getGuideLayer()
        var image = GameGuideAnims.imageMove(action, paras, layer)        
        if (layer) {
            layer.addChild(image)
        }
    }
}
GameGuideRunner.removeImageMove = function (index, action, paras) {
    var self = this
    if ((action.runTime || "start") === "end") {
        var layer = GameGuideData.getInstance().getGuideLayer()
        if (layer) {
            layer.runAction(cc.CallFunc.create(function () {
                var image = GameGuideAnims.imageMove(action, paras, layer)
                layer.addChild(image)
            }))
        }
    }
}
GameGuideRunner.runPropIntLimit = function (index, action, paras) {
    var self = this
    var node = GameGuideAnims.propInteractLimit(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(node)
    }
}
GameGuideRunner.runItemShow = function (index, action, paras) {
    let self = this
    // body
    GameGuideFunc.gameItemShow(action, paras)
}
// const GuideLinkClass = 'clover-guide-link'
// GameGuideRunner.runLink = function (index, action, paras) {
//     let link = document.createElement('a')
//     link.className = GuideLinkClass
//     let innerPos
//     if (window.META.platform === XcloverPlatform.qq && !action.extra) {
//         link.href = action.href
//         link.text = action.text
//         innerPos = cc.p(action.x, action.y)
//         link.style.left = 0
//     }else {
//         let image = document.createElement('img')
//         image.src = ASSETS_PUBLIC_PATH + action.extra.img
//         link.appendChild(image)
//         link.href = action.extra.href
//         innerPos  = cc.p(action.extra.x, action.extra.y)
//         link.style.left = action.extra.left + 'px'
//         link.target = "_blank"
//     }
//     let pos = GameGuidePosition.gameplayArea(null, cc.p(innerPos.x, innerPos.y), null, null, null, action.posRatio, action.posAdd, action.sizeRatio)
//     link.style.position = 'absolute'
//     link.style.right = 0
//     link.style.textAlign = 'center'
    
//     link.style.bottom = pos[1] + 'px'
//     link.style.padding = '10px'
    
//     link.style.fontSize = '16px'
//     link.style.color = action.color

//     document.body.appendChild(link)
// }
// GameGuideRunner.runLeadLink = function (index, action, paras) {
//     if (switchs.canLead) {
//         if (window.META.platform === XcloverPlatform.qq &&  kIsNewUser && action.href) {
//             GameGuideRunner.runLink.apply(GameGuideRunner, arguments)
//         }else if (action.extra && action.extra.href) {
//             GameGuideRunner.runLink.apply(GameGuideRunner, arguments)
//         }
//     } 
// }
// GameGuideRunner.removeLink = GameGuideRunner.removeLeadLink = function () {
//     let links = document.getElementsByClassName(GuideLinkClass)
//     for (let i = 0; i < links.length; i++) {
//         links[i].remove()
//     }
// }

GameGuideRunner.runDoubleSpeed = function (index, action, paras) {
    var self = this
    require("clover/gameGuide/GameGuideDoubleSpeedPanel").show(function(){
        //打开暂停面板，显示气泡
        var ui = cc.Director.getInstance().getRunningScene().ui
        if (!ui.running){
            return
        }
        ui.onPausedCkick(true)

    })
        // self.runDoubleSpeedBubble.bind(self)
       
}

GameGuideRunner.runDoubleSpeedBubble = function(){
    var self = this
    let instance = GameSpeedManager.getInstance()
    if (instance.isEffectLevel()) {
        instance.setSpeed(instance.levelType, 1)
        instance.updateGameSpeed()
    }
    let showBubble = function(){
        var ui = cc.Director.getInstance().getRunningScene().ui
        if (!ui.running){
            return
        }
        var bubble = require("clover/gameGuide/GameGuideDoubleSpeedBubble").show()
        ui.addChild(bubble)
    }
    setTimeout(showBubble, 15000)
}
GameGuideRunner.runShowFruit = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // ref 
    let scene = cc.Director.getInstance().getRunningScene()
    let sceneName = tostring(((scene || table()).class || table()).__cname)
    if (sceneName !== "GameScene") {
        return 
    }
    if (scene.logic === null || scene.logic.gameMode === null || scene.logic.gameMode.class.__cname === null || scene.logic.gameMode.class.__cname !== "IceMode") {
        return 
    }
    GameExtandPlayLogic.showHintAnimation4IceMode(scene.logic, function () {
        let __VA_ARG = $slice(arguments, 0)
        // 引导结束后恢复加速
        // GameSpeedUp.getInstance().unlockSpeed()
        // GameSpeedUp.getInstance().speedUp()
    })
}
GameGuideRunner.runAnimalDialogV2 = function (index, action, paras) {
    let panel = GameGuideAnims.animalDialogV2(action, paras)
    var layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(panel)
    }
}
GameGuideRunner.runAnimalDialogV2Hand = function (index, action, paras) {
    let track = GameGuideAnims.animalDialogV2HandTrack(action, paras)
    paras = paras || {}
    paras.track = track
    let hand = GameGuideAnims.animalDialogV2Hand(action, paras)
    let layer = GameGuideData.getInstance().getGuideLayer()
    if (layer) {
        layer.addChild(track)
        layer.addChild(hand)
    }
}

module.exports = GameGuideRunner
